class LayoutSwitcher extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', () => {
      let cols = this.dataset.cols;
      let switchersContainer = this.closest('.jc-layout-swithers');
      let isMobileLayout = switchersContainer.dataset.mobile;
      let switchers = switchersContainer.querySelectorAll('layout-switcher');

      switchers.forEach((btn) => {
        btn.classList.remove('active');
      });
      this.classList.add('active');

      setActiveLayout(isMobileLayout, cols);
    })

    function setActiveLayout(isMobileLayout, cols) {

      let productGrid = document.querySelector('[js-product-grid]');
      let currentClasses = productGrid.classList;
      currentClasses.forEach(function (className) {
        if (className.startsWith('lg:jc-grid-cols-') && isMobileLayout == 'false' ) {
          productGrid.classList.remove(className);
          productGrid.classList.add('lg:jc-grid-cols-' + cols);
          productGrid.setAttribute('data-desktop-cols', cols);
          localStorage.setItem('desktoplayout', cols);
        }

        if ( className.startsWith('max-lg:jc-grid-cols-') && isMobileLayout == 'true') {
          productGrid.classList.remove(className);
          productGrid.classList.add('max-lg:jc-grid-cols-' + cols);
          productGrid.setAttribute('data-mobile-cols', cols);
          localStorage.setItem('mobilelayout', cols);
        }
      });
    }
  }
}

customElements.define('layout-switcher', LayoutSwitcher);

function handleLayoutChanges() {
  const windowWidth = window.innerWidth;
  const layoutSwitcher = document.querySelector('.jc-layout-switcher[data-cols="6"]');

  if (windowWidth <= 1400 && layoutSwitcher && layoutSwitcher.classList.contains('active')) {
    layoutSwitcher.classList.remove('active');
    layoutSwitcher.previousElementSibling.click();
  }
}

const resizeObserver = new ResizeObserver(handleLayoutChanges);

resizeObserver.observe(document.documentElement);
handleLayoutChanges();

class FilterToggleBtn extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', () => {
      let facetsContainer = document.querySelector('.jc-facets');
      facetsContainer.classList.toggle('active');

      this.classList.toggle('active');
    })
  }
}

customElements.define('filter-toggle-btn', FilterToggleBtn);
